import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { toast } from 'sonner';

// Helper to get initial state from cookies
const token = Cookies.get('gym-token');

const initialState = {
  user: null,
  token: token || null,
  isAuthenticated:token?true:false ,
  loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      Cookies.set('gym-token', token, { expires: 7 }); // Save for 7 days
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove('gym-token');
      toast.success("Logged out successfully");
    },
    setUser: (state, action) => {
      state.user = action.payload;
    }
  },
});

export const { setCredentials, logout, setUser } = authSlice.actions;
export default authSlice.reducer;